module.exports = __webpack_public_path__ + "img/Baumschmuck.d203c923.jpg";